/**
 * FinaSettings API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import { getFinaSettings, updateFinaSettings } from "../generated/fina-settings/fina-settings";

import { wrapMethod } from "./utils";

export const finaSettings = {
  /** @see getFinaSettings */
  list: wrapMethod(getFinaSettings),

  /** @see updateFinaSettings */
  update: wrapMethod(updateFinaSettings),
} as const;

export type FinaSettingsApi = typeof finaSettings;
